import * as React from 'react'
import { TextFieldProps } from 'cs-kevlar-react/lib/es/TextField'
import { JsonInput } from '../JsonInput'
import { GlobalConfiguration as GlobalConfigurationDto } from '../../api'

type GlobalConfigurationProps = TextFieldProps & {
  configuration: GlobalConfigurationDto | null
  title: string
}

const inputProps = {
  readOnly: true,
}

export const GlobalConfiguration: React.FunctionComponent<GlobalConfigurationProps> = ({
  configuration,
  title,
  ...rest
}) => {
  return (
    <JsonInput
      json={configuration}
      label={title}
      rows={5}
      inputProps={inputProps}
      {...rest}
    />
  )
}
